import objectOwnerDetailsFactory from './utils/objectOwnerDetailsFactory'

export const store = {
  getters: {
    objectOwnerDetailsFactory,
  },
}
